import BaseApiService from './baseApi';

class CashbackService extends BaseApiService {
  constructor() {
    super('/api/v1/partner/');
  }

  async list(params) {
    return this.get('cashback', params);
  }

  async balance(data) {
    return this.get('balance', data);
  }

  async add(data) {
    return this.post('cashback', data);
  }

  async terminate(id) {
    return this.delete('cashback/'+id);
  }

  // async update(id, data) {
  //   return this.put(id, data);
  // }

  // async deleteUser(id) {
  //   return this.delete(id);
  // }
}

const cashbackService = new CashbackService();

export default cashbackService;
